import { useRequiredContext } from "@redotech/react-util/context";
import { createContext } from "react";
import type { GlobalConversationCollections } from "../db/collections";

export const GlobalConversationCollectionsContext = createContext<
  GlobalConversationCollections | undefined
>(undefined);
GlobalConversationCollectionsContext.displayName =
  "GlobalConversationCollectionsContext";

export function useGlobalConversationCollections(): GlobalConversationCollections {
  return useRequiredContext(GlobalConversationCollectionsContext);
}
